export default __webpack_public_path__ + "assets/silver.f220eed2032c5fda95fae89bcc733191.svg";